<div style="display:flex;justify-content:flex-end;padding:4px 4px 0">
  <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<ng-container>
    <mat-form-field class="me-3">
        <mat-label>Cuenta contable</mat-label>
        <mat-select [(ngModel)]="accountNumber" (selectionChange)="onChangeAccount()">
            <mat-option
                [value]="partnerSelected.accountingModels118Id">{{partnerSelected.accountingModels118}}</mat-option>
            <mat-option
                [value]="partnerSelected.accountingModels551Id">{{partnerSelected.accountingModels551}}</mat-option>
        </mat-select>
    </mat-form-field>
</ng-container>

<ng-container *ngIf="ready == false">
    <mat-card appearance="outlined">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </mat-card>
</ng-container>

<ng-container *ngIf="ready && error === true && accountNumber != null">
    <mat-card appearance="outlined">
        <p>{{error_msg}}</p>
        <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
    </mat-card>
</ng-container>

<ng-container *ngIf="ready && error === false && accountNumber != null">
    <mat-card appearance="outlined">
        <p mat-dialog-title>
          Mayor de <strong>{{partnersName}}</strong> Cuenta Contable - {{numberAccountingAccount}}
        </p>
        <br>
        <p>El mayor trae la información de todas las actividades</p>
        <hr>
        <div class="text-center">
            <strong>Aportado: </strong> {{totalContributedPartners}} <br />
            <strong>Devuelto: </strong> {{totalReturnedPartners}} <br />
            <strong>Total: </strong> {{totalPartners}}
        </div>
    </mat-card>
    <br />
    <app-table [columns]="headerTableP" [dataSource]="dataSourceTransaction" [[dataSource]="dataSourceTransaction"
        [hasButton]="true" [actionsTemplate]="actionsButtonsProvider" [hasHeaderActions]="true"
        [headerActionsTemplate]="headerActionsButtons">
    </app-table>

    <ng-template #headerActionsButtons>
        <ul class="custom-class">
            <li (click)="getExcel()">
                <a>Generar Excel</a>
            </li>
        </ul>
    </ng-template>
</ng-container>
